import { useState } from 'react'
import { createAPI } from 'gyl-common/utils/createAPI'
import { fetchHasBindShopCount } from '@/modules/distribute/features/checkHasBindShop'
import CheckHasBindShopModal from '@/modules/distribute/components/CheckHasBindShopModal'
import { useMemoizedFn } from 'ahooks'

const useHasBindShop = () => {
    const [loading, setLoading] = useState(false)
    const [count, setCount] = useState(0)

    const fetchHasBindShop = useMemoizedFn(async () => {
        setLoading(true)

        const shopCount = await fetchHasBindShopCount()

        setCount(shopCount)
        setLoading(false)

        return shopCount
    })

    const hasBindShop = count > 0

    const checkHasBindShop = useMemoizedFn(() => {
        if (!hasBindShop) {
            createAPI(CheckHasBindShopModal)
            throw Error()
        }

        return true
    }, [hasBindShop])

    return {
        hasBindShop,
        hasBindShopLoading: loading,
        fetchHasBindShop,
        checkHasBindShop,
    }
}

export default useHasBindShop
